const Z_INDEX = {
  CONTEXT_MENU: 1150,
  TOOLTIP: 1200,
  POPOVER: 1200,
};
const ANIMATION_PROPERY_NAME = 'opacity';

export { ANIMATION_PROPERY_NAME as A, Z_INDEX as Z };
